// @flow

import React, { Component } from 'react';
import styled from 'styled-components';

import type { DownloadType } from '../../../../components/Download';

import { LinkButton, RouteButton, ActionButton, ExternalLinkButton } from '../../../../components/Button';
import Page from '../../../../components/Page';
import Section, { GradientSection } from '../../../../components/Section';

import Arrow from '../../../../components/Arrow';
import vortexGearBg from '../../../../images/vortex-gear-bg.png';

import trackEvent from '../track-event';

const MainSection = styled(Section)`
  background-color: ${props => props.theme.sectionBg1};
  background-image: url(${vortexGearBg}), linear-gradient(to bottom, ${props => props.theme.sectionBg1}, ${props => props.theme.sectionBg2});
  background-repeat: no-repeat, repeat;
  background-position: right 50% bottom 100%, center;
  padding-bottom: 4em;
  > p {
    margin-bottom: 2em;
  }
`;

const AboutSection = styled(GradientSection)`
  padding: 0;
  text-align: center;
  > div {
    padding: 0 2em 2em;
    > div {
      text-align: left;
    }
  }
  > svg {
    position: relative;
    top: -23px;
  }
`;

type State = {
  isRevealed:boolean
}

class Landing extends Component<{}, State> {

  state = {
    isRevealed: false
  }

  onDownload = (download: DownloadType) => {
    const { title, ...rest } = download;
    trackEvent(`Download Resource: ${title}`, rest);
  }

  render() {
    return (
      <Page title="Vortex Speed Reducers">
        <MainSection primary>
          <h1>Vortex Shaft Mount Calculator</h1>
          <p>Use this calculator to ensure proper output torque is selected in your application.</p>
          <RouteButton data-primary to="/tools/vortex/calculator">
            Use the Calculator
          </RouteButton>
        </MainSection>

        <AboutSection>
          <Arrow />
          <div>
            <h2>About Vortex Speed Reducers</h2>
            <ExternalLinkButton href="https://vortexreducer.com" target="_blank">
              <span>vortexreducer.com</span>
              <span className="ss-link"></span>
            </ExternalLinkButton>

            <div>
              <p>At Vortex, we build reducers that are strong enough to handle the toughest applications. Our reducers are designed for rugged reliability and smooth-running performance.</p>
              {
                this.state.isRevealed && (
                  <div>
                    <p>Vortex shaft mount reducers are a direct drop in for many different manufacturers including Dodge style TXT style reducers and are mechanically interchangeable with most commonly used reducers. Vortex worm gear boxes are a direct drop in for many different manufacturers including Boston Gear.</p>
                    <p>If you are ready to make the switch or want to learn more about which Vortex reducer is best suited for your application, contact your local distributor or Vortex representative.</p>
                  </div>
                )
              }
            </div>

            <p>
              <ActionButton
                icon={this.state.isRevealed ? 'navigateup' : 'navigatedown'}
                onClick={e => this.setState({ isRevealed: !this.state.isRevealed })}
                transparent
              >
                Read {this.state.isRevealed ? 'Less' : 'More'}
              </ActionButton>
            </p>
          </div>
        </AboutSection>

        <Section>
          <h2>Product Info</h2>

          <RouteButton data-block data-secondary to="/contact">Contact Sales</RouteButton>
          <LinkButton block secondary href="mailto:info@baartgroup.com">Get Support</LinkButton>
        </Section>
      </Page>
    );
  }

}

export default Landing;



// WEBPACK FOOTER //
// ./src/views/tools/vortex/views/Landing.js